import { Component, Input, OnInit, Output, EventEmitter, NgZone, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../user/services/user.service';
import { Dependent } from '../../../user/models/user-profile.model';
import { RequestsService } from '../services/requests.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { NotificationService } from '../../../../shared/services/notification.service';
import { LaboratoryRequest } from '../models/laboratory.model';
import { Laboratory, LaboratoryResponse } from '../models/laboratory-response.model';

@Component({
  selector: 'app-medical-checkup',
  standalone: true,
  imports: [
    CommonModule,
    MatRadioModule,
    MatIconModule,
    FormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './medical-checkup.component.html',
  styleUrls: ['./medical-checkup.component.scss']
})
export class MedicalCheckupComponent implements OnInit {
  @Input() medicalCheckupData: any = null;
  @Input() fromServiceRequest: boolean = false;
  
  @Output() laboratoriesFound: EventEmitter<any> = new EventEmitter();
  @Output() laboratorySelected: EventEmitter<any> = new EventEmitter();
  
  selectedPatient: string = 'titular';
  nameOwner: string = '';
  phoneOwner: string = '';
  keyOwner: string = '';
  dependent: Dependent[] = [];
  userProfile: any;
  birthdate: string = '';
  
  // Propiedades para estudios médicos
  selectedStudy: string = '';
  selectedLocation: string = '';
  selectedLaboratory: string = '';
  availableStudies: any[] = [];
  filteredStudies: any[] = [];
  studySearchText: string = '';
  nearbyLaboratories: any[] = [];
  selectedLaboratoryData: any = null;
  
  // Propiedades para ubicaciones
  locationSearchText: string = '';
  availableLocations: any[] = [];
  filteredLocations: any[] = [];
  selectedLocationData: any = null;
  showLocationSuggestions: boolean = false;
  googleSuggestions: any[] = [];
  autocompleteService: any = null;
  placesService: any = null;
  
  // Propiedades para dependientes
  showAllDependents: boolean = false;
  
  // Contacto de teléfono
  contactoDeTelefono: string = '0';
  
  // Estado de búsqueda de laboratorios
  isSearchingLaboratories: boolean = false;

  pdfBlob: Blob | null = null;

  private getServiceContact(): void {
    try {
      const contacts = JSON.parse(localStorage.getItem('servicesContact') || '[]');
      const clSubServicio = parseInt(this.route.snapshot.queryParams['clSubServicio']);
      const serviceContact = contacts.find((c: any) => c.clSubServicio === clSubServicio);
      this.contactoDeTelefono = serviceContact?.phone || '0';
    } catch {
      this.contactoDeTelefono = '0';
    }
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private requestServ: RequestsService,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      this.nameOwner = userObj.name || '';
      this.phoneOwner = userObj.phone || '';
      this.keyOwner = userObj.memberships || '';
      this. birthdate = userObj.birthdate || '';
    }
    
    if (this.fromServiceRequest && this.medicalCheckupData) {
      this.loadDataFromServiceRequest();
    }
    
    this.getServiceContact();
    this.getDetailUser();
    this.loadAvailableLocations();
    this.getCheckupCatalog();
    
    // Listener para cerrar sugerencias al hacer clic fuera
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.relative')) {
        this.showLocationSuggestions = false;
      }
    });
  }

  getDetailUser() {
    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.userProfile = res;
          this.dependent = res.dependents;
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }

  getCheckupCatalog() {
    const account = parseInt(localStorage.getItem('account') || '0');
    this.requestServ.getCheckupCatalog(account).subscribe({
      next: (res) => {
        if (res.success && res.data) {
          this.loadAvailableStudies(res.data);
        }
      },
      error: (err) => console.error('Error al obtener catálogo de checkup', err)
    });
  }

  loadAvailableStudies(catalogo?: any[]) {
    if (catalogo) {
      this.availableStudies = catalogo.map(item => ({
        id: item.idestudios,
        description: item.estudio
      }));
    } else {
      this.availableStudies = [];
    }
    
    this.filteredStudies = [...this.availableStudies];
  }

  onStudyChange() {
    if (this.selectedStudy && this.selectedLocation) {
      this.searchNearbyLaboratories();
    }
  }

  addNewDependent() {
    this.router.navigate(['add-dependiente'], { queryParams: { returnUrl: this.router.url } });
  }

  loadAvailableLocations() {
    // Simulación de ciudades disponibles
    this.availableLocations = [
      { id: '1', name: 'Toluca', state: 'Estado de México', lat: 19.2926, lng: -99.6568 },
      { id: '2', name: 'Ixtlahuaca', state: 'Estado de México', lat: 19.5667, lng: -99.7667 },
      { id: '3', name: 'Metepec', state: 'Estado de México', lat: 19.2665, lng: -99.6009 },
      { id: '4', name: 'Lerma', state: 'Estado de México', lat: 19.2833, lng: -99.5167 },
      { id: '5', name: 'Zinacantepec', state: 'Estado de México', lat: 19.2833, lng: -99.7333 },
      { id: '6', name: 'Ciudad de México', state: 'CDMX', lat: 19.4326, lng: -99.1332 }
    ];
    this.filteredLocations = [...this.availableLocations];
  }

  onLocationSearch(event: any) {
    const searchText = event.target.value.trim();
    this.locationSearchText = searchText;
    
    if (searchText.length >= 3) {
      this.showLocationSuggestions = true;
      this.initGoogleAutocomplete();
      this.searchLocationsByText(searchText);
    } else {
      this.showLocationSuggestions = false;
      this.googleSuggestions = [];
    }
  }

  onLocationFocus() {
    if (this.locationSearchText.length >= 3) {
      this.showLocationSuggestions = true;
    }
  }

  filterLocations(searchText: string) {
    if (!searchText || searchText === 'current') {
      this.filteredLocations = [...this.availableLocations];
      return;
    }
    
    const filterValue = searchText.toLowerCase();
    this.filteredLocations = this.availableLocations.filter(location => 
      location.name.toLowerCase().includes(filterValue) || 
      location.state.toLowerCase().includes(filterValue)
    );
  }

  initGoogleAutocomplete() {
    // Verificar si Google Maps está disponible
    if (typeof google !== 'undefined' && google?.maps?.places) {
      if (!this.autocompleteService) {
        try {
          this.autocompleteService = new google.maps.places.AutocompleteService();
        } catch (error) {
          console.warn('Error inicializando Google Places:', error);
        }
      }
    } else {
      // Reintentar después de un breve delay si Google Maps no está listo
      setTimeout(() => {
        if (typeof google !== 'undefined' && google?.maps?.places && !this.autocompleteService) {
          this.initGoogleAutocomplete();
        }
      }, 1000);
    }
  }

  searchLocationsByText(searchText: string) {
    if (this.autocompleteService && this.autocompleteService !== 'new_api') {
      // Buscar ubicaciones por texto completo (dirección, código postal, ciudad, colonia)
      this.autocompleteService.getPlacePredictions({
        input: searchText + ', México',
        types: ['geocode', 'establishment'],
        componentRestrictions: { country: 'mx' }
      }, (predictions: any, status: any) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
          this.googleSuggestions = predictions.slice(0, 8);
        } else {
          this.googleSuggestions = [];
          // Fallback: crear sugerencia manual si parece código postal
          if (/^\d{5}$/.test(searchText)) {
            this.createFallbackSuggestion(searchText);
          }
        }
      });
    } else {
      // Fallback: crear sugerencia manual si parece código postal
      if (/^\d{5}$/.test(searchText)) {
        this.createFallbackSuggestion(searchText);
      }
    }
  }
  
  createFallbackSuggestion(postalCode: string) {
    // Crear una sugerencia manual para continuar el flujo
    this.googleSuggestions = [{
      description: `Código Postal ${postalCode}, México`,
      place_id: `manual_${postalCode}`,
      structured_formatting: {
        main_text: `CP ${postalCode}`,
        secondary_text: 'México'
      }
    }];
  }

  selectCurrentLocation() {
    this.showLocationSuggestions = false;
    this.locationSearchText = 'Obteniendo ubicación actual...';
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          
          // Hacer geocoding inverso para obtener dirección, CP, municipio y estado
          if (typeof google !== 'undefined' && google.maps) {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
              if (status === 'OK' && results[0]) {
                const place = results[0];
                const addressComponents = place.address_components;
                
                let postalCode = '';
                let municipality = '';
                let state = '';
                
                addressComponents.forEach((component: any) => {
                  if (component.types.includes('postal_code')) {
                    postalCode = component.long_name;
                  }
                  if (component.types.includes('locality') || component.types.includes('administrative_area_level_2')) {
                    municipality = component.long_name;
                  }
                  if (component.types.includes('administrative_area_level_1')) {
                    state = component.long_name;
                  }
                });
                

                this.selectedLocation = 'current';
                this.selectedLocationData = {
                  id: 'current',
                  name: 'Mi ubicación actual',
                  lat: lat,
                  lng: lng,
                  address: place.formatted_address,
                  postalCode: postalCode,
                  municipality: municipality,
                  state: state
                };
                this.locationSearchText = 'Mi ubicación actual';
                
                // Scroll to top of the page
                window.scrollTo({ top: 0, behavior: 'smooth' });
                
                if (this.selectedStudy) {
                  this.searchNearbyLaboratories();
                }
              } else {
                // Fallback si el geocoding inverso falla
                this.setFallbackCurrentLocation(lat, lng);
              }
            });
          } else {
            // Fallback si Google no está disponible
            this.setFallbackCurrentLocation(lat, lng);
          }
        },
        (error) => {
          console.error('Error obteniendo ubicación:', error);
          this.locationSearchText = '';
          
          // Manejar diferentes tipos de errores de geolocalización
          let errorMessage = 'No se pudo obtener tu ubicación actual';
          let errorTitle = 'Error de ubicación';
          
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = 'Para usar esta función, necesitas permitir el acceso a tu ubicación. Por favor, habilita la geolocalización en tu navegador y vuelve a intentarlo.';
              errorTitle = 'Acceso a ubicación denegado';
              break;
            case error.POSITION_UNAVAILABLE:
              errorMessage = 'No se pudo determinar tu ubicación. Verifica tu conexión a internet e intenta nuevamente.';
              errorTitle = 'Ubicación no disponible';
              break;
            case error.TIMEOUT:
              errorMessage = 'La solicitud de ubicación tardó demasiado. Intenta nuevamente.';
              errorTitle = 'Tiempo de espera agotado';
              break;
            default:
              errorMessage = 'Ocurrió un error inesperado al obtener tu ubicación. Intenta nuevamente.';
              break;
          }
          
          this.notificationService.showError(errorMessage, errorTitle);
        }
      );
    } else {
      this.notificationService.showError('Tu navegador no soporta geolocalización', 'Error');
    }
  }
  
  private setFallbackCurrentLocation(lat: number, lng: number) {
    this.selectedLocation = 'current';
    this.selectedLocationData = {
      id: 'current',
      name: 'Mi ubicación actual',
      lat: lat,
      lng: lng,
      address: 'Ubicación actual',
      postalCode: '',
      municipality: '',
      state: ''
    };
    this.locationSearchText = 'Mi ubicación actual';
    
    // Scroll to top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    if (this.selectedStudy) {
      this.searchNearbyLaboratories();
    }
  }

  selectPredefinedLocation(location: any) {
    this.selectedLocation = location.id;
    this.selectedLocationData = location;
    this.locationSearchText = location.name;
    this.showLocationSuggestions = false;
    
    // Scroll to top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    if (this.selectedStudy) {
      this.searchNearbyLaboratories();
    }
  }

  selectGoogleLocation(suggestion: any) {
    
    // Verificar si es una sugerencia manual (fallback)
    if (suggestion.place_id.startsWith('manual_')) {
      const postalCode = suggestion.place_id.replace('manual_', '');
      this.selectedLocation = suggestion.place_id;
      
      // Usar geocoding para obtener coordenadas reales del código postal
      if (typeof google !== 'undefined' && google.maps) {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 
          address: `${postalCode}, México`,
          componentRestrictions: { country: 'MX' }
        }, (results: any, status: any) => {
          if (status === 'OK' && results[0]) {
            const place = results[0];
            const addressComponents = place.address_components;
            
            // Extraer municipio y estado de los componentes de dirección
            let municipality = '';
            let state = '';
            
            addressComponents.forEach((component: any) => {
              if (component.types.includes('locality') || component.types.includes('administrative_area_level_2')) {
                municipality = component.long_name;
              }
              if (component.types.includes('administrative_area_level_1')) {
                state = component.long_name;
              }
            });
            
            this.selectedLocationData = {
              id: suggestion.place_id,
              name: `CP ${postalCode}`,
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
              address: place.formatted_address,
              postalCode: postalCode,
              municipality: municipality,
              state: state
            };
          } else {
            // Fallback a coordenadas por defecto
            this.selectedLocationData = {
              id: suggestion.place_id,
              name: `CP ${postalCode}`,
              lat: 19.2926,
              lng: -99.6568,
              address: `Código Postal ${postalCode}, México`,
              postalCode: postalCode,
              municipality: '',
              state: ''
            };
          }
          
          this.locationSearchText = this.selectedLocationData.address;
          this.showLocationSuggestions = false;
          
          if (this.selectedStudy) {
            this.searchNearbyLaboratories();
          }
        });
      } else {
        // Si Google no está disponible, usar coordenadas por defecto
        this.selectedLocationData = {
          id: suggestion.place_id,
          name: `CP ${postalCode}`,
          lat: 19.2926,
          lng: -99.6568,
          address: `Código Postal ${postalCode}, México`,
          postalCode: postalCode,
          municipality: '',
          state: ''
        };
        this.locationSearchText = this.selectedLocationData.address;
        this.showLocationSuggestions = false;
        
        // Scroll to top of the page
        window.scrollTo({ top: 0, behavior: 'smooth' });
        
        if (this.selectedStudy) {
          this.searchNearbyLaboratories();
        }
      }
      return;
    }
    
    // Usar geocoding para obtener coordenadas (Google Places normal)
    if (typeof google !== 'undefined' && google.maps) {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ placeId: suggestion.place_id }, (results: any, status: any) => {
        if (status === 'OK' && results[0]) {
          const place = results[0];
          const addressComponents = place.address_components;
          
          // Extraer código postal, municipio y estado
          let postalCode = '';
          let municipality = '';
          let state = '';
          
          addressComponents.forEach((component: any) => {
            if (component.types.includes('postal_code')) {
              postalCode = component.long_name;
            }
            if (component.types.includes('locality') || component.types.includes('administrative_area_level_2') || component.types.includes('sublocality_level_1')) {
              municipality = component.long_name;
            }
            if (component.types.includes('administrative_area_level_1')) {
              state = component.long_name;
            }
          });
          
          this.selectedLocation = suggestion.place_id;
          
          // Si no hay código postal o municipio, hacer geocodificación inversa
          if (!postalCode || !municipality) {
            const reverseGeocoder = new google.maps.Geocoder();
            reverseGeocoder.geocode({
              location: { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() }
            }, (reverseResults: any, reverseStatus: any) => {
              if (reverseStatus === 'OK' && reverseResults[0]) {
                const reverseComponents = reverseResults[0].address_components;
                reverseComponents.forEach((component: any) => {
                  if (component.types.includes('postal_code') && !postalCode) {
                    postalCode = component.long_name;
                  }
                  if ((component.types.includes('locality') || component.types.includes('administrative_area_level_2') || component.types.includes('sublocality_level_1')) && !municipality) {
                    municipality = component.long_name;
                  }
                });
              }
              
              this.selectedLocationData = {
                id: suggestion.place_id,
                name: place.address_components[0].long_name,
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
                address: place.formatted_address,
                postalCode: postalCode || "23245",
                municipality: municipality,
                state: state
              };
              
              this.locationSearchText = suggestion.description;
              this.showLocationSuggestions = false;
              window.scrollTo({ top: 0, behavior: 'smooth' });
              
              if (this.selectedStudy) {
                this.searchNearbyLaboratories();
              }
            });
          } else {
            this.selectedLocationData = {
              id: suggestion.place_id,
              name: place.address_components[0].long_name,
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
              address: place.formatted_address,
              postalCode: postalCode,
              municipality: municipality,
              state: state
            };
            
            this.locationSearchText = suggestion.description;
            this.showLocationSuggestions = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            
            if (this.selectedStudy) {
              this.searchNearbyLaboratories();
            }
          }
        }
      });
    }
  }

  searchNearbyLaboratories() {
    if (!this.selectedStudy || !this.selectedLocationData) return;
    
    const selectedStudyData = this.availableStudies.find(s => s.id === this.selectedStudy);
    if (!selectedStudyData) return;

    // Paso 1: Mover mapa a la dirección seleccionada
    this.moveMapToLocation();
    
    // Paso 2: Preparar datos para el servicio
    const requestData: LaboratoryRequest = {
      identifier: {
        tenants: "adff7f6a-e97d-11eb-9a03-0242ac130003",
        app: "PortalAsistencia"
      },
      petition: {
        laboratory: [selectedStudyData.description],
        Cp: this.selectedLocationData.postalCode || "23245",
        Ent: this.selectedLocationData.state || "",
        Mun: this.selectedLocationData.municipality || "",
        lat: this.selectedLocationData.lat?.toString() || "",
        long: this.selectedLocationData.lng?.toString() || ""
      }
    };

    // Paso 3: Consumir servicio find con timeout de 50 segundos
    this.isSearchingLaboratories = true;
    console.log('🚀 Iniciando búsqueda de laboratorios...');

    this.requestServ.findLaboratories(requestData).subscribe({
      next: (response: LaboratoryResponse) => {
        console.log('📦 Respuesta del servicio:', response);
        
        if (response.success && response.data && (Array.isArray(response.data) ? response.data.length > 0 : true)) {
          console.log('✅ Procesando laboratorios...');
          // Paso 4: Procesar y mostrar pines en el mapa
          this.nearbyLaboratories = this.flattenLaboratories(response.data);
          
          // Emitir laboratorios al mapa después de procesarlos
          const emitData = {
            laboratories: this.nearbyLaboratories,
            centerLocation: {
              lat: this.selectedLocationData?.lat,
              lng: this.selectedLocationData?.lng,
              isCurrentLocation: this.selectedLocationData?.id === 'current'
            }
          };
          
          console.log('📡 Emitiendo laboratorios al mapa:', emitData);
          this.laboratoriesFound.emit(emitData);
          
          this.notificationService.showSuccess(`Se encontraron ${this.nearbyLaboratories.length} laboratorios`, 'Éxito');
          this.isSearchingLaboratories = false;
        } else {
          console.log('❌ Sin resultados');
          this.nearbyLaboratories = [];
          this.laboratoriesFound.emit({ laboratories: [], centerLocation: null });
          this.notificationService.showError('No se encontraron laboratorios', 'Sin resultados');
          this.isSearchingLaboratories = false;
        }
      },
      error: (error) => {
        console.error('❌ Error:', error);
        this.nearbyLaboratories = [];
        this.laboratoriesFound.emit({ laboratories: [], centerLocation: null });
        this.notificationService.showError('Error al buscar laboratorios', 'Error');
        this.isSearchingLaboratories = false;
      }
    });
  }
  
  // Método para mover el mapa a la ubicación seleccionada
  private moveMapToLocation() {
    if (!this.selectedLocationData) return;
    
    console.log('🗺️ Moviendo mapa a:', this.selectedLocationData);
    
    const locationData = {
      lat: this.selectedLocationData.lat,
      lng: this.selectedLocationData.lng,
      address: this.selectedLocationData.address || this.selectedLocationData.name
    };
    
    // Emitir ubicación para mover el mapa
    this.laboratoriesFound.emit({
      laboratories: [],
      centerLocation: {
        lat: locationData.lat,
        lng: locationData.lng,
        isCurrentLocation: this.selectedLocationData.id === 'current'
      }
    });
  }

  private flattenLaboratories(data: any): any[] {
    console.log('🔍 flattenLaboratories - data recibida:', data);
    
    const flattened: any[] = [];
    let id = 1;
    
    const userLat = this.selectedLocationData?.lat || 19.4326;
    const userLng = this.selectedLocationData?.lng || -99.1332;
    
    console.log('📍 Coordenadas del usuario:', { userLat, userLng });
    
    // Manejar diferentes estructuras de datos
    if (Array.isArray(data)) {
      data.forEach(item => {
        if (Array.isArray(item)) {
          // Estructura: Laboratory[][]
          item.forEach((lab) => {
            // Usar coordenadas reales del laboratorio o fallback con offset
            const labLat =  lab.lat;
            const labLng =  lab.lng;
            
            let finalLat, finalLng;
            if (labLat && labLng && !isNaN(parseFloat(labLat)) && !isNaN(parseFloat(labLng))) {
              finalLat = parseFloat(labLat);
              finalLng = parseFloat(labLng);
            } else {
              // Fallback: usar ubicación del usuario con offset aleatorio
              const offsetLat = (Math.random() - 0.5) * 0.02;
              const offsetLng = (Math.random() - 0.5) * 0.02;
              finalLat = userLat + offsetLat;
              finalLng = userLng + offsetLng;
            }
            
            const labData = {
              id: id.toString(),
              name: lab.LABORATORIO_NAME || lab.name,
              address: lab.address,
              state: lab.state,
              city: lab.city,
              study: lab.study,
              hasStudy: true,
              lat: finalLat,
              lng: finalLng
            };
            
            console.log(`🏥 Laboratorio ${id}:`, labData);
            flattened.push(labData);
            id++;
          });
        } else {
          // Estructura: Laboratory[]
          const labLat = item.latitude || item.lat || item.LATITUDE;
          const labLng = item.longitude || item.lng || item.LONGITUDE;
          
          let finalLat, finalLng;
          if (labLat && labLng && !isNaN(parseFloat(labLat)) && !isNaN(parseFloat(labLng))) {
            finalLat = parseFloat(labLat);
            finalLng = parseFloat(labLng);
          } else {
            // Fallback: usar ubicación del usuario con offset aleatorio
            const offsetLat = (Math.random() - 0.5) * 0.02;
            const offsetLng = (Math.random() - 0.5) * 0.02;
            finalLat = userLat + offsetLat;
            finalLng = userLng + offsetLng;
          }
          
          const labData = {
            id: id.toString(),
            name: item.LABORATORIO_NAME || item.name,
            address: item.address,
            state: item.state,
            city: item.city,
            study: item.study,
            hasStudy: true,
            lat: finalLat,
            lng: finalLng
          };
          
          console.log(`🏥 Laboratorio ${id}:`, labData);
          flattened.push(labData);
          id++;
        }
      });
    }
    
    console.log('📋 Total laboratorios procesados:', flattened.length);
    
    return flattened;
  }
  


  onLaboratorySelected(laboratory: any) {
    this.selectedLaboratory = laboratory.id;
    this.selectedLaboratoryData = laboratory;
    this.laboratorySelected.emit(laboratory);
    
    // Scroll hacia el área del laboratorio seleccionado y botón solicitar
    setTimeout(() => {
      this.scrollToSelectedLaboratory();
    }, 100);
  }

  // Método público para actualizar selección desde el mapa
  updateSelectedLaboratory(laboratory: any) {
    this.selectedLaboratory = laboratory.id;
    this.selectedLaboratoryData = laboratory;
    
    // Scroll hacia el área del laboratorio seleccionado y botón solicitar
    setTimeout(() => {
      this.scrollToSelectedLaboratory();
    }, 100);
  }

  canRequestCheckup(): boolean {
    return !!(this.selectedPatient && this.selectedStudy && this.selectedLocation && this.nearbyLaboratories.length > 0);
  }
  
  // Método para emitir laboratorios con reintentos para servicios lentos
  private emitLaboratoriesWithRetry(emitData: any) {
    // Emisión inmediata
    this.ngZone.run(() => {
      this.laboratoriesFound.emit(emitData);
      this.cdr.detectChanges();
      console.log('📡 Emisión inmediata');
    });
    
    // Emisiones con delays progresivos para servicios lentos
    const delays = [200, 500, 1000, 2000, 3000, 5000];
    
    delays.forEach((delay, index) => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.laboratoriesFound.emit(emitData);
          this.cdr.detectChanges();
          console.log(`📡 Emisión ${index + 2} (${delay}ms)`);
        });
      }, delay);
    });
  }
  
  // Método público para debug - forzar emisión de laboratorios
  public forceEmitLaboratories() {
    if (this.nearbyLaboratories.length > 0) {
      const emitData = {
        laboratories: this.nearbyLaboratories,
        centerLocation: {
          lat: this.selectedLocationData?.lat,
          lng: this.selectedLocationData?.lng,
          isCurrentLocation: this.selectedLocationData?.id === 'current'
        }
      };
      
      console.log('🚀 Forzando emisión de laboratorios:', emitData);
      this.emitLaboratoriesWithRetry(emitData);
      return emitData;
    }
    return null;
  }
  
  onStudySearchChange(searchText: string) {
    this.studySearchText = searchText;
    this.filterStudies(searchText);
  }

  filterStudies(searchText: string) {
    if (!searchText) {
      this.filteredStudies = [...this.availableStudies];
      return;
    }
    
    const filterValue = searchText.toLowerCase();
    this.filteredStudies = this.availableStudies.filter(study => 
      study.description.toLowerCase().includes(filterValue)
    );
  }

  onStudySelected(event: any) {
    const selectedDescription = event.option.value;
    const study = this.availableStudies.find(s => s.description === selectedDescription);
    if (study) {
      this.selectedStudy = study.id;
      this.studySearchText = selectedDescription;
      this.onStudyChange();
    }
  }

  onStudyFocus(event: any) {
    this.filteredStudies = [...this.availableStudies];
  }
  
  onStudyKeyPress(event: any) {
    // Permitir navegación con teclado
  }

  toggleDependents() {
    this.showAllDependents = !this.showAllDependents;
  }

  loadDataFromServiceRequest(): void {
    if (this.medicalCheckupData) {
      this.selectedPatient = this.medicalCheckupData.patient || 'titular';
      this.selectedStudy = this.medicalCheckupData.study?.id || '';
      this.selectedLaboratory = this.medicalCheckupData.laboratory?.id || '';
      this.nearbyLaboratories = this.medicalCheckupData.laboratories || [];
      
      if (this.selectedStudy) {
        const study = this.availableStudies.find(s => s.id === this.selectedStudy);
        if (study) {
          this.studySearchText = study.name;
        }
      }
    }
  }

  async requestCheckup(): Promise<void> {
    if (!this.canRequestCheckup()) {
      this.notificationService.showError('Por favor completa todos los campos requeridos', 'Información');
      return;
    }
    
    // Validación adicional para laboratorio seleccionado
    if (!this.selectedLaboratoryData) {
      this.notificationService.showError('Por favor selecciona un laboratorio del mapa', 'Laboratorio requerido');
      return;
    }
    
    const selectedStudyData = this.availableStudies.find(s => s.id === this.selectedStudy);
    const selectedLabData = this.selectedLaboratoryData || this.nearbyLaboratories.find(l => l.id === this.selectedLaboratory);
    const selectedAddress = this.selectedLocationData.address;

    console.log(selectedAddress);
    
    
    if (this.fromServiceRequest) {
      this.loader.show();
      
      const selectedName = this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient;
      const { firstName, lastName, secondLastName } = this.splitFullName(selectedName);
      const { firstName: ownerFirstName, lastName: ownerLastName, secondLastName: ownerSecondLastName } = this.splitFullName(this.nameOwner);
      
      const accountData = localStorage.getItem('account');
      const accountId = accountData ? JSON.parse(accountData) : 536;
      
      const payload = {
        identifier: {
          tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
          app: 'PortalAsistencia'
        },
        petition: {
          serviceId: 4,
          subServiceId: 377,
          hasAssistance: false,
          key: this.keyOwner,
          areaCode1: '044',
          phone1: this.phoneOwner,
          cp: selectedLabData?.postalCode || '',
          callenum: '',
          stateCode: '',
          municipalityCode: '',
          statusId: 0,
          accountId: accountId,
          appUserId: 1,
          countryId: 115,
          contactTypeId: 15,
          serviceTypeId: 1,
          sendCharge: false,
          hasAppointment: false,
          isRelevant: false,
          gender: 1,
          isOk: true,
          hasQuotation: false,
          isSise2: true,
          serviceReceptionId: 10,
          personId: 1,
          username: firstName,
          paternalSurname: lastName,
          userSecondLastName: secondLastName,
          contactName: this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient,
          userFirstNamePf: ownerFirstName,
          userLastNamePf: ownerLastName,
          userSecondLastNamePf: ownerSecondLastName,
          ourUser: this.nameOwner,
          externalCabRepName: 'API CLIENTES',
          folio: crypto.randomUUID(),
          longitude: this.selectedLocationData?.lng?.toString() || selectedLabData?.lng?.toString() || '',
          latitude: this.selectedLocationData?.lat?.toString() || selectedLabData?.lat?.toString() || '',
          incidentDescription: `Check-up Médico - Estudio: ${selectedStudyData?.description} - Laboratorio: ${selectedLabData?.name} - Dirección: ${selectedLabData?.address}, ${selectedLabData?.state}`,
          fechanacimiento: this.getSelectedPatientBirthdate(),
        }
      };
      
      
      // Código original comentado para cuando se solucione el servicio
      
      this.requestServ.sendMedicalCheckupRequest(payload).subscribe({
        next: async (res) => {
          const expediente = res?.response?.id || res?.data?.clExpediente || res?.clExpediente;
          
          if (expediente) {
            // Obtener email del usuario desde localStorage
            const userData = localStorage.getItem('user');
            let userEmail = '';
            if (userData) {
              try {
                const userObj = JSON.parse(userData);
                userEmail = userObj.email || '';
              } catch (e) {
                console.warn('Error parsing user data:', e);
              }
            }
            // Formatear fecha actual como "YYYY-MM-DD HH:MM:SS para los campos de fechalaboratorio, fechacita "
            const fecha = new Date();
            const año = fecha.getFullYear();
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const dia = String(fecha.getDate()).padStart(2, '0');
            const horas = String(fecha.getHours()).padStart(2, '0');
            const minutos = String(fecha.getMinutes()).padStart(2, '0');
            const segundos = String(fecha.getSeconds()).padStart(2, '0');
            const fechaFormateada = `${año}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
            
            console.log("fecha",fechaFormateada);

            const ProductByAccount = localStorage.getItem('ProductByAccount');
            const now = new Date();
            const vigenciaDate = new Date(now.getTime() + (60 * 24 * 60 * 60 * 1000)); // 60 días después
            
            
            const generatePDF = {
              folio: this.generateFolio(expediente, now),
              cuenta: ProductByAccount ? JSON.parse(ProductByAccount).name : '',
              autorizacion: expediente,
              fecha: `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`,
              medico: 'GERENCIA DE OPERACION MEDICA',
              titular: this.selectedPatient === 'titular',
              beneficiario: this.selectedPatient !== 'titular',
              paciente: this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient,
              edad: this.calculateAge(this.getSelectedPatientBirthdate()).toString(),
              nacimiento: this.getSelectedPatientBirthdate().substring(0,10),
              estudioCheck: true,
              estudio: '- ' + (selectedStudyData?.description || ''),
              vigencia: `${vigenciaDate.getDate().toString().padStart(2, '0')}/${(vigenciaDate.getMonth() + 1).toString().padStart(2, '0')}/${vigenciaDate.getFullYear()}`,
              sucursal: `${selectedLabData?.address}, ${selectedLabData?.state}`.trim().replace(/^,\s*|,\s*$/g, '')
            };
            
            try {
              const { PdfGenerator } = await import('./generate-pdf/model-pdf');
              const blob = await PdfGenerator.generatePdfAsBlob(generatePDF);
              
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = `checkup-${expediente.replace('#', '')}.pdf`;
              link.click();
              
              URL.revokeObjectURL(link.href);
            } catch (error) {
              console.error('Error generando PDF:', error);
              this.notificationService.showError('Error al generar PDF', 'Error');
            }

            // continuar con la navegación — pasar el Blob en el state para descarga local
            this.router.navigate(['/service/confirm/', 'Check-up Médico'], {
                  state: {
                    patient: this.selectedPatient,
                    patientName: this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient,
                    serviceName: 'Check-up Médico',
                    study: selectedStudyData,
                    laboratory: selectedLabData,
                    location: this.selectedLocationData,
                    fromSelection: true,
                    serviceResponse: {
                      id: expediente,
                      fechaapertura: res?.response?.fechaapertura || res?.response?.fecharegistro || new Date().toISOString(),
                      telefono1: res?.response?.telefono1 || '+525555555555'
                    },
                    pdf: this.pdfBlob
                  }
            });

          } else {
            this.loader.hide();
            this.notificationService.showError('No se pudo obtener el expediente', 'Error');
          }
        },
        error: (err) => {
          this.loader.hide();
          console.error('Error al enviar solicitud de Check-up', err);
          this.notificationService.showError('Error al procesar la solicitud', 'Error');
        }
      });
      
    } else {

      
      this.router.navigate(['/service/request/Check-up Médico'], {
        state: {
          patient: this.selectedPatient,
          patientName: this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient,
          study: selectedStudyData,
          laboratory: selectedLabData,
          location: this.selectedLocationData,
          laboratories: this.nearbyLaboratories,
          fromMedicalCheckup: true
        }
      });
      

    }
  }
  
  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(/\s+/).filter(p => p);
    if (parts.length <= 1) return { firstName: parts[0] || '', lastName: '', secondLastName: '' };
    if (parts.length === 2) return { firstName: parts[0], lastName: parts[1], secondLastName: '' };
    if (parts.length === 3) return { firstName: parts[0], lastName: parts[1], secondLastName: parts[2] };
    // Para nombres con 4 o más partes, asumir que los primeros 2 son nombres y los últimos 2 son apellidos
    return {
      firstName: parts.slice(0, 2).join(' '),
      lastName: parts[parts.length - 2],
      secondLastName: parts[parts.length - 1]
    };
  }

  private generateFolio(expediente: string, fecha: Date): string {
    const año = fecha.getFullYear().toString().slice(-2);
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    return `CHUP${año}${mes}${expediente}`;
  }

  private getSelectedPatientBirthdate(): string {
    let birthdate = '';
    
    if (this.selectedPatient === 'titular') {
      birthdate = this.birthdate;
    } else {
      // Buscar el dependiente seleccionado
      const selectedDependent = this.dependent.find(dep => dep.name === this.selectedPatient);
      birthdate = selectedDependent?.birthdate || this.birthdate;
    }
    
    // Formatear la fecha al formato requerido: YYYY-MM-DD HH:MM:SS
    if (birthdate) {
      try {
        const date = new Date(birthdate);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day} 00:00:00`;
        }
      } catch (error) {
        console.warn('Error al formatear fecha de nacimiento:', error);
      }
    }
    
    // Fallback: fecha por defecto si no se puede formatear
    return '1990-01-01 00:00:00';
  }

  private cleanPdfData(pdfData: string): string {
    return pdfData.replace(/[{}"\'\s]/g, '');
  }

  private calculateAge(birthdate: string): number {
    if (!birthdate) return 0;
    
    try {
      const birth = new Date(birthdate);
      const today = new Date();
      
      if (isNaN(birth.getTime())) return 0;
      
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      
      return age > 0 ? age : 0;
    } catch (error) {
      console.warn('Error al calcular edad:', error);
      return 0;
    }
  }

  private scrollToSelectedLaboratory() {
    // Usar el ID específico del laboratorio seleccionado
    const selectedLabElement = document.getElementById('selected-laboratory-section');
    
    if (selectedLabElement) {
      selectedLabElement.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  }

  clearLocationSearch(): void {
    this.locationSearchText = '';
    this.showLocationSuggestions = false;
  }

  private sendCheckupWA(base64Pdf: string, expediente: string) {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const phoneNumber = user.phone || '';
    const selectedStudyData = this.availableStudies.find(s => s.id === this.selectedStudy);
    const studyName = selectedStudyData?.description?.replace(/\s+/g, '-').toLowerCase() || '';

    const payload = {
      identifier: {
        tenants: "adff7f6a-e97d-11eb-9a03-0242ac130003",
        app: "13"
      },
      petition: {
        phoneNumber: parseInt(phoneNumber),
        // phoneNumber: 7461171449, //estatico numero de Francisco
        templateId: 54,
        mediaBase64: base64Pdf,
        mediaType: "document",
        mediaName: `checkup-${studyName}-${expediente}.pdf`
      }
    };

    this.requestServ.sendCheckupWA(payload).subscribe({
      next: (response) => {
      },
      error: (error) => {
        console.error('Error al enviar PDF por WhatsApp:', error);
      }
    });
  }
/*
  convertPdfToBase64(pdfData: any) {
    import('./generate-pdf/model-pdf').then(async ({ PdfGenerator }) => {
      const base64 = await PdfGenerator.generatePdfAsBase64(pdfData);
      //console.log('PDF Base64:', base64);
    }).catch(error => {
      console.error('Error converting PDF to base64:', error);
    });
  }*/
}